import { useMemo } from 'react';
import { get, useFormContext } from 'react-hook-form';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import Option from '@/components/form/types/Option.ts';
import useGetAirports from '@/features/dashboard/tfg/hooks/useGetAirports.ts';
import { TransportInputForm } from '@/features/dashboard/tourTransport/schemas/transportSchema.ts';

const AirportSelectInput = ({ index }: { index: number }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TransportInputForm>();

  const { data: airports = [], isLoading } = useGetAirports();

  // react-select filters these options client-side as the user types.
  const options: Option[] = useMemo(
    () =>
      [...airports]
        .sort((a, b) => a.name.localeCompare(b.name, 'pl'))
        .map((airport) => ({ value: airport.code, label: airport.name })),
    [airports],
  );

  const fieldPath = `variants.${index}.airportCode` as const;

  return (
    <SingleSelectInput
      fieldName={fieldPath}
      control={control}
      options={options}
      isLoading={isLoading}
      label="Lotnisko docelowe"
      required
      placeholder="Wyszukaj lotnisko"
      error={get(errors, `${fieldPath}.message`)}
    />
  );
};

export default AirportSelectInput;
